export default __webpack_public_path__ + "static/media/6106.0f49d813.svg";